import script from "./DimensionScores.vue?vue&type=script&setup=true&lang=js"
export * from "./DimensionScores.vue?vue&type=script&setup=true&lang=js"

import "./DimensionScores.vue?vue&type=style&index=0&id=49399cce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49399cce"]])

export default __exports__